const styles = () => ({ autoComplete: { width: 300 } });
export default styles;
